
  const ua = navigator.userAgent.toLowerCase();
   
  function browser( extension ){
    var ext=""
    if (ua.indexOf("safari") != -1) {
      if (ua.indexOf("chrome") > -1 ) {
        ext = extension[0] // Chrome
      } else {
        ext = extension[1] // Safari
      }
    }else{
      ext = extension[0]
    }
    return ext;
  }

  /*if (ua.indexOf("safari") != -1) {

  }*/


const bgImageColor = {
  methods: {
    bg(image, color) {
      if (image != "none") {
        return (
          "background-color: #" +
          color +
          "; background-image: url(" +
          require("@/assets/images/" + image) +
          ")"
        );
      } else {
        return "background-color: #" + color + "; background-image: none";
      }
    }
  }
};

const bgImage = {
  methods: {
    bgPortrait(image, position, ypos, extension) {
      var ext = browser(extension);
      return (
        position +
        ":0px; background-position-x : " +
        position +
        " ; background-image: url(" +
        require("@/assets/images/" + image + "." + ext) +
        "); background-position-y: " +
        ypos
      );
    }
  }
};

const image = {
  methods: {
    image(image, extension) {
      let defaultImage =
        "https://p7.hiclipart.com/preview/711/621/180/error-computer-icons-orange-error-icon.jpg"; // just set default
      //let path = folder;
      try {
        return require("@/assets/images/" + image + "." + extension);
      } catch (e) {
        return defaultImage;
      }
    }
  }
};

const bgThread = {
  methods: {
    bgThread(image) {
      return (
        "background-image: url(" +
        require("@/assets/images/" + image) +
        ");    background-size: cover;"
      );
    }
  }
};

const imageDiagram = {
  methods: {
    imageDiagram(image, extension) {
      let defaultImage =
        "https://p7.hiclipart.com/preview/711/621/180/error-computer-icons-orange-error-icon.jpg"; // just set default
      //let path = folder;
      try {
        var widthWindows = window.innerWidth;

        if (widthWindows <= 480) {
          return require("@/assets/images/Grupo304.svg");
        } else {
          return require("@/assets/images/" + image + "." + extension[0]);
        }
      } catch (e) {
        return defaultImage;
      }
    }
  }
};

export { bgImage, bgImageColor, image, bgThread, imageDiagram };
